import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class CurriculumCourseCard extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    author: PropTypes.shape({
      name: PropTypes.string.isRequired,
      headline: PropTypes.string.isRequired,
      avatar: PropTypes.string,
      url: PropTypes.string.isRequired,
      job_title: PropTypes.string,
      company_name: PropTypes.string,
      company_url: PropTypes.string,
    }).isRequired,
    url: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    introduction: PropTypes.string.isRequired,
    communityLogoPath: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div
        className="Card-v2 Card-v2-padding"
        data-card=""
        data-card-title={this.props.title}
        data-card-author={this.props.author.name}
        data-card-type="Course">
        <a href={this.props.url} className="Card--clickable-link" />

        <div className="u-flex">
          <div className="u-w-1/3">
            <a href={this.props.url} data-curriculum-link={this.props.title}>
              <div className="CurriculumCard-thumb CurriculumCard--small">
                <div className="CurriculumCard-image">
                  <img alt={this.props.title} src={this.props.image} />
                </div>
              </div>
            </a>
          </div>
          <div className="u-w-2/3">
            <h3 className="CurriculumCard-title">
              <a href={this.props.url} data-curriculum-link={this.props.title}>
                {this.props.title}
              </a>
            </h3>
            <div className="CurriculumCard-author">
              Curated by <a href={this.props.author.url}>{this.props.author.name}</a>
            </div>
            <div className="">{this.props.introduction}</div>
            <div
              className="Card-footer-logo u-float-right"
              style={{ backgroundImage: `url(${this.props.communityLogoPath})` }}
            />
          </div>
        </div>
      </div>
    );
  }
}
